import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import $ from 'jquery';

import { PAGE_THREATS } from '../../../config/pages';

class ThreatsTwo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
        this.scroll = this.scroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.scroll);
        window.addEventListener('scroll', this.scroll);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.scroll);
        window.removeEventListener('scroll', this.scroll);
    }

    scroll() {
        if (this.props.page === PAGE_THREATS && $('.container-threats-2').length > 0 && this.state.show === false) {
            const winTop = $(window).scrollTop();
            const winHeight = $(window).height();

            const elemTop = $('.container-threats-2').offset().top;
            if (elemTop < (winTop + (winHeight / 2))) {
                this.setState({ show: true });
            }
        }
    }

    render() {
        const { show } = this.state;
        const { t } = this.props;

        return (
            <div className="container-threats-2" id="container-threats-2">
                <div className="layout">
                    <div className="page-threats-2" id="page-threats-2">
                        <div className="section-title" id="section-title-2">
                            <h2 dangerouslySetInnerHTML={ { __html: t('threats.two.section.title') } }/>
                        </div>
                        <div className="section-boxes threats-2-boxes" id="threats-2-boxes">
                            {
                                t('threats.two.boxes').map((text, index) => {
                                    const boxClassName = cx('section-box', 'threats-2-box', { show });
                                    return (
                                        <div className={ boxClassName } key={ index }>
                                            <div className="image">
                                                <img src={ require(`../../../assets/images/threats/2/icon-${ (index + 1) }.svg`) } alt="Lemlock threats"/>
                                            </div>
                                            <div className="section-text-16">
                                                <p dangerouslySetInnerHTML={ { __html: text } }/>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                        <div className="section-text threats-2-text" id="threats-2-text">
                            <p dangerouslySetInnerHTML={ { __html: t('threats.two.text') } }/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ThreatsTwo.propTypes = {
    t: PropTypes.func.isRequired,
    page: PropTypes.string.isRequired
};

export default ThreatsTwo;



// WEBPACK FOOTER //
// ./src/components/content/threats/ThreatsTwo.jsx